import React from 'react';
import { Button } from '../ui/Button';
export function Hero() {
  const productImg = 'https://cdn.magicpatterns.com/uploads/sqWj2RGF8QLq23vTiDj7BE/heylloyd-image-1771222482108.png';
  return <section className="relative overflow-hidden bg-gradient-to-b from-amber-50 to-white pt-6 pb-12 lg:pt-24 lg:pb-28" data-id="element-161">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-163">
          {/* Content */}
          <div className="w-full lg:w-1/2 text-center lg:text-left z-10" data-id="element-164">
            <span className="inline-block py-1 px-3 rounded-full bg-amber-100 text-amber-800 text-sm font-semibold tracking-wide uppercase mb-6" data-id="element-165">
              For Women Over 45
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-stone-900 leading-tight mb-6" data-id="element-166">
              If You're Over 45 and Your Belly Feels Like an{' '}
              <span className="text-amber-600" data-id="element-167">"Inflated Balloon"</span> Every
              Afternoon…
            </h1>

            <h2 className="text-xl sm:text-2xl text-stone-600 font-medium mb-8 leading-relaxed" data-id="element-168">
              It's Not Your Age. It's Your Hormones.
            </h2>

            <p className="text-lg text-stone-600 mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-169">
              Stop the cardio. Stop the starvation diets. Discover the 5-minute
              "Ancient Code" that flushes out menopause bloat and firms your
              skin—starting tomorrow morning.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start w-full" data-id="element-170">
              <a href="#pricing" className="inline-flex items-center justify-center font-bold transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white shadow-[0_4px_14px_0_rgba(245,158,11,0.39)] hover:shadow-[0_6px_20px_rgba(245,158,11,0.23)] hover:-translate-y-0.5 border border-amber-400/20 px-8 sm:px-12 py-4 sm:py-5 text-lg sm:text-xl w-full sm:w-auto min-h-[60px] text-center leading-tight" data-id="element-171">
                YES! END MY BLOAT NOW →
              </a>
            </div>
            <p className="mt-4 text-sm text-stone-500 italic" data-id="element-172">
              *Instant Digital Download – PDF Format
            </p>
          </div>

          {/* Image */}
          <div className="w-full lg:w-1/2 relative" data-id="element-173">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-amber-200/20 rounded-full blur-3xl -z-10" data-id="element-174"></div>
            <img src={productImg} alt="The Golden Root Ritual Book Cover" className="w-full max-w-md mx-auto lg:max-w-full rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-175" />
          </div>
        </div>
      </div>
    </section>;
}